import { createApp, h } from "vue";
import wrapper from "vue3-webcomponent-wrapper";


// import Counter from "./components/Counter.vue";
import FetchForm from "./components/FetchForm.vue";

import { VueReCaptcha } from "vue-recaptcha-v3";

const createAppWrapper = (FetchForm) => {
  return createApp(FetchForm).use(VueReCaptcha, {
    siteKey: "6LdfzO8eAAAAAMlSrxRGKXBfD1NSvr-qgAPW7scb",
  });
};

const webComponent = wrapper(FetchForm, createAppWrapper, h);

window.customElements.define("mk-vue-form", webComponent);
